// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_dd-2";
export var aiChatCartContainerExit = "_dd-4";
export var aiChatContainerLarge = "_dd-0";
export var aiChatContainerSmall = "_dd-1";
export var aiChatIcon = "_dd-6";
export var slideInFromRight = "_dd-3";
export var slideOutToRight = "_dd-5";